/**
 * Payment frequency of the simulated premium — how often the entered amount is due.
 *
 * ── WHY A cp-LOCAL MIRROR OF A bm ENUM
 *
 * The simulation request carries `paymentFrequency` as {@code bm.enums.PaymentRecurringAmountFrequency}
 * (`ProvisionSimulationRequestDto`), which is where the engine normalises the entered amount to a
 * monthly premium. cp is a different feature group than bm, so the constant is mirrored here rather
 * than imported across the group boundary — the same crossing cw makes for the same enum
 * (`cw-payment-frequency.model.ts`, "the crossing is made by ENUM NAME").
 *
 * ── THE WIRE FORM IS THE ORDINAL, AND THAT IS MEASURED
 *
 * `POST /mvsa/cp/provisionTypes/{id}/simulate` REFUSES the enum name: a request carrying
 * `"paymentFrequency": "MONTHLY"` answers HTTP 400 "Failed to read request", and so does one
 * carrying `"role": "main"`; the same request with `0` for both answers 200 (measured 2026-09-02
 * against clone/rathje, both fields isolated separately). Callers must therefore send the ORDINAL.
 *
 * Position-based mirror: the declaration order below MUST match the backend exactly and new
 * constants MUST only be appended at the end — never inserted between existing ones, which would
 * silently re-map every value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionPaymentFrequency {

    /** Ordinal 0 — "Monatlich". */
    MONTHLY,

    /** Ordinal 1 — "Vierteljährlich". */
    QUARTERLY,

    /** Ordinal 2 — "Halbjährlich". */
    SEMI_ANNUALLY,

    /** Ordinal 3 — "Jährlich". */
    YEARLY
}
